import { useEffect, useState } from 'react';

export const useSort = ({ columnDefinition, initialSortBy, onSort, canSort }) => {
  const initialSortByColumn = columnDefinition.find((column) => column.accessor === initialSortBy.id);

  const [selectedColumn, setSelectedColumn] = useState(
    canSort
      ? {
          value: initialSortByColumn,
          label: initialSortByColumn.Header,
        }
      : null,
  );

  useEffect(() => {
    if (canSort) {
      setSelectedColumn({
        value: initialSortByColumn,
        label: initialSortByColumn.Header,
      });
    }
  }, [canSort, initialSortByColumn]);

  const handleSort = (value, column) => {
    onSort([
      {
        id: column.accessor,
        desc: value === 'desc',
        column,
      },
    ]);
  };

  return { selectedColumn, setSelectedColumn, handleSort };
};
